import { render } from "./schedule-tuesday.vue?vue&type=template&id=42956667"
import script from "./schedule-tuesday.vue?vue&type=script&lang=js"
export * from "./schedule-tuesday.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__